import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';
import { AppConfigsService } from '../../../config/app-configs.service';
import { HttpService, IResponseLower } from '../../../shared/cardholders-core/services/http-service.service';
import { ICheckForCardRequest } from '../interfaces/ICheckForCardRequest.interface';
import { ITransferOrderMaxAndForeignRequest } from '../interfaces/ITransferOrderMaxAndForeignRequest.interface';
import { ITransferOrderMaxAndForeignResponse } from '../interfaces/ITransferOrderMaxAndForeignResponse.interface';
import { ICheckForCardResponse, ICheckForCard, IDestinationCard } from '../interfaces/ICheckForCardResponse.interface';
import { IContentAndData } from '../interfaces/IContentAndData.interface';
import { IContentResponse } from '../interfaces/IContentResponse.interface';
import { IDirectDebitBenefitDataRequest } from '../interfaces/IDirectDebitBenefitDataRequest.interface';

import { IDirectDebitBenefitData } from '../interfaces/IDirectDebitBenefitDataResponse.interface';

@Injectable()
export class DirectDebitService {
    baseApi = '';
    contents$ = new BehaviorSubject<IContentResponse>(null);
    loaderStatus = new BehaviorSubject<boolean>(false);
    checkForCardResponse: ICheckForCardResponse;
    selectedDestCard: IDestinationCard;
    transferOrderMaxAndForeignResponse: ITransferOrderMaxAndForeignResponse;
    isHokBebefit = false;
    loaderCounter = 0;
    next = '';
    rcError = 0;
    fromError = 'getContentAndData';
    transferOrderMaxAndForeignRc: number;
    directDebitBenefitData: IDirectDebitBenefitData;

    constructor(private httpService: HttpService, private appConfigsService: AppConfigsService) {
        this.baseApi = `${this.appConfigsService.appConfigs.apiUrl}/registered/directDebit`;
    }
    set loader(add: boolean) {
        if (add) {
            this.loaderCounter += 1;
            this.loaderStatus.next(true);
        } else {
            this.loaderCounter -= 1;
            if (this.loaderCounter < 0) {
                this.loaderCounter = 0;
            }
            if (this.loaderCounter === 0) {
                this.loaderStatus.next(false);
            }
        }
    }

    getContent(): Observable<IResponseLower<IContentAndData>> {
        this.loader = true;
        return this.httpService.getLower<IContentAndData>(`${this.baseApi}/getContentAndData`).pipe(
            tap((x) => {
                this.loader = false;

                if (x.result && x.result.content) {
                    this.contents$.next(x.result.content);
                }
            })
        );
    }

    checkForCard(req: ICheckForCardRequest[]): Observable<IResponseLower<ICheckForCardResponse>> {
        this.loader = true;
        return this.httpService.postLower<ICheckForCardResponse>(`${this.baseApi}/CheckForCard`, req).pipe(
            tap((x) => {
                if (x.returnCode !== 9) {
                    this.checkForCardResponse = x.result;
                }
                if (x.returnCode === 0) {
                    if (x.result.destinationCards.length === 1) {
                        this.selectedDestCard = x.result.destinationCards[0];
                    }
                }
                this.loader = false;
            })
        );
    }

    getBenefitsData(req: IDirectDebitBenefitDataRequest): Observable<IResponseLower<IDirectDebitBenefitData>> {
        this.loaderStatus.next(true);
        return this.httpService.postLower<IDirectDebitBenefitData>(`${this.baseApi}/getBenefitsData`, req).pipe(
            tap((res) => {
                if (res.returnCode === 0) {
                    this.directDebitBenefitData = res.result;
                }
                this.loaderStatus.next(false);
            })
        );
    }

    transferDirectDebits(
        req: ITransferOrderMaxAndForeignRequest
    ): Observable<IResponseLower<ITransferOrderMaxAndForeignResponse>> {
        this.loaderStatus.next(true);
        return this.httpService
            .postLower<ITransferOrderMaxAndForeignResponse>(`${this.baseApi}/transferOrderMaxAndForeign`, req)
            .pipe(
                tap((res) => {
                    if (res.returnCode === 0 || res.returnCode === 18 || res.returnCode === 20) {
                        this.transferOrderMaxAndForeignResponse = res.result;
                        this.transferOrderMaxAndForeignRc = res.returnCode;
                    }
                    this.loaderStatus.next(false);
                })
            );
    }
}
